// Do not edit.
import { ShaderStore } from "../../Engines/shaderStore.js";
var name = "geometryVertexDeclaration";
var shader = "uniform mat4 viewProjection;\nuniform mat4 view;";
// Sideeffect
ShaderStore.IncludesShadersStore[name] = shader;
/** @hidden */
export var geometryVertexDeclaration = { name: name, shader: shader };
//# sourceMappingURL=geometryVertexDeclaration.js.map